import {
  customerMarketShopfrontApi,
  customerMarketShopfrontJobsApi,
  marketApi,
  Site
} from '@envato/foundation-types'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'

import {
  fetchTopSellersPageDataBySite,
  onBeforeTopSellersPageView
} from '../../common/actions/topSellersPage'
import { IRootState } from '../../common/reducers'
import { IEnhancedLocation } from '../../common/reducers/reactRouterLocation'
import { decorateSearchResult } from '../../common/selectors/searchResults'
import { IPageComponent } from '../../typings/pageComponent'
import { IItem } from '../../typings/searchResults'
import TopSellersPage from '../pages/topSellers/topSellersPage'

interface IOwnProps extends RouteConfigComponentProps<any> {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
}

interface IStateProps {
  metadata: customerMarketShopfrontApi.ISeoMetadata | null
  items: IItem[]
  featuredAuthors: customerMarketShopfrontJobsApi.IFeaturedAuthorsResult
  location: IEnhancedLocation
  experimentsReady: boolean
  isLoading: boolean
  currentSite: Site
  subcategories?: marketApi.ICategory[]
  currentCategoryName?: string
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const {
    topSellersPage: {
      topSellers: topSellersMatches,
      subcategories,
      currentCategoryName,
      featuredAuthors,
      isLoading,
      metadata
    }
  } = state
  const { location } = state.router
  const { experimentsReady } = state.experiments
  const { currentSite } = state.common

  const items =
    (topSellersMatches &&
      topSellersMatches.matches.map(match =>
        decorateSearchResult(state, match)
      )) ||
    []

  return {
    metadata,
    items,
    featuredAuthors: featuredAuthors || [],
    location,
    experimentsReady,
    currentSite,
    isLoading,
    subcategories,
    currentCategoryName
  }
}

export type Props = IOwnProps & IStateProps

const createTopSellersPageContainer = (
  component: React.ComponentType<Props>
) => {
  const pageComponent: IPageComponent<Props> = component as IPageComponent<
    Props
  >

  pageComponent.loadData = (store, location, apiUrlPrefix) =>
    store.dispatch(fetchTopSellersPageDataBySite(location, apiUrlPrefix))

  pageComponent.onBeforePageView = store =>
    store.dispatch(onBeforeTopSellersPageView())

  return connect<IStateProps, null, IOwnProps, IRootState>(mapStateToProps)(
    pageComponent
  )
}

export default createTopSellersPageContainer(TopSellersPage)
